import { useFlags } from 'launchdarkly-react-client-sdk';
import isFeatureEnabled from 'app/launch-darkly/is-feature-enabled';
import { FEATURE_FLAGS } from 'app/launch-darkly/featureFlags';

export default function useSettingsFlags() {
  const featureFlags = useFlags();

  return {
    hasConsent: isFeatureEnabled({ featureFlags, flagName: FEATURE_FLAGS.configurableConsentMvp }),
    hasWebhooks: isFeatureEnabled({ featureFlags, flagName: FEATURE_FLAGS.webhookConfig }),
    hasTags: isFeatureEnabled({ featureFlags, flagName: FEATURE_FLAGS.pipelineTagsMvp }),
  };
}
